var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,4.8c-.7,0-1.2-.5-1.2-1.2V1.2c0-.7.5-1.2,1.2-1.2s1.2.5,1.2,1.2v2.4c0,.7-.5,1.2-1.2,1.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,12c-.7,0-1.2-.5-1.2-1.2v-2.4c0-.7.5-1.2,1.2-1.2s1.2.5,1.2,1.2v2.4c0,.7-.5,1.2-1.2,1.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,19.2c-.7,0-1.2-.5-1.2-1.2v-2.4c0-.7.5-1.2,1.2-1.2s1.2.5,1.2,1.2v2.4c0,.7-.5,1.2-1.2,1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,19.2H3.6c-2,0-3.6-1.6-3.6-3.6v-3.6c0-.7.5-1.2,1.2-1.2s1.2-.5,1.2-1.2-.5-1.2-1.2-1.2-1.2-.5-1.2-1.2v-3.6C0,1.6,1.6,0,3.6,0h16.8c2,0,3.6,1.6,3.6,3.6v3.6c0,.7-.5,1.2-1.2,1.2s-1.2.5-1.2,1.2.5,1.2,1.2,1.2,1.2.5,1.2,1.2v3.6c0,2-1.6,3.6-3.6,3.6ZM2.4,13v2.6c0,.7.5,1.2,1.2,1.2h16.8c.7,0,1.2-.5,1.2-1.2v-2.6c-1.4-.5-2.4-1.8-2.4-3.4s1-2.9,2.4-3.4v-2.6c0-.7-.5-1.2-1.2-1.2H3.6c-.7,0-1.2.5-1.2,1.2v2.6c1.4.5,2.4,1.8,2.4,3.4s-1,2.9-2.4,3.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductTicket);
export default __webpack_public_path__ + "static/media/product-ticket.dfafd9cd782fc5409fc00cd0527fe91d.svg";
export { ForwardRef as ReactComponent };